






import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import LogRocket from 'logrocket';

@Component({
  name: 'App',
})
export default class App extends Vue {
  @State('layout') layout!: string;
  @State('user') user!: any;

  @Watch('user.profile', { immediate: true })
  onUserLogin(value: any) {
    if (value?.id) {
      LogRocket.init('ybnvin/resclick-v2', {
        dom: {
          textSanitizer: false,
          inputSanitizer: false,
        },
      });
      LogRocket.identify(this.user.profile.id, {
        name: this.user?.profile?.name + ' ' + this.user?.profile?.surname,
        email: this.user?.profile?.email,
      });
      console.log('INIT');
    }
  }
}
